module.exports = __webpack_public_path__ + "img/island.6d33ce91.png";